import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { HiringResourcesFetchResponse } from '@core/tellent-assign-members-to-jobs-types';
import { TellentHttpApiService } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class HiringResourcesHttpClient {
  protected readonly httpApi = inject(TellentHttpApiService);

  public fetchJobs(appGuid: string): Observable<HiringResourcesFetchResponse> {
    return this.httpApi.get(`/api/app/${appGuid}/recruitment/hiring-resources/jobs`, null, {
      skipCompany: true,
    });
  }

  public fetchTalentPools(appGuid: string): Observable<HiringResourcesFetchResponse> {
    return this.httpApi.get(`/api/app/${appGuid}/recruitment/hiring-resources/talent-pools`, null, {
      skipCompany: true,
    });
  }
}
